import React from "react";
import { Popover, Table, Whisper } from "rsuite";
import { useTranslation } from "react-i18next";
import {
  displayField,
  isNotEmpty,
  isEmptyVal,
  processMinute,
  displayDateField,
  displayDateTimeField,
} from "../../../utils/helpers";

const LastOrderCell = ({
  rowData,
  positionFromRight = "50",
  withFirstOrder = true,
  ...props
}: {
  rowData: any;
  positionFromRight?: any;
  withFirstOrder?: boolean;
}) => {
  const { t } = useTranslation();
  const { Cell } = Table;
  const orderItems = isNotEmpty(rowData.last_order_item_names)
    ? rowData.last_order_item_names.split(",")
    : null;
  const speaker = isNotEmpty(orderItems) ? (
    <Popover title={t("LAST") + " " + t("ORDER") + " " + t("ITEMS") + ":"}>
      {orderItems.map((element: string) => {
        if (isNotEmpty(element)) {
          return <p key={element}>{displayField(element)}</p>;
        }
      })}
      <p>
        <b>
          {t("SERVICE")} {t("DATE")}:
        </b>{" "}
        <br />
        <p> {displayDateField(rowData.last_service_date)}</p>
      </p>
      <p>
        <b>
          {t("ORDER")} {t("STATUS")}:
        </b>{" "}
        <br />
        <p> {displayField(rowData.last_order_status)}</p>
      </p>
      {withFirstOrder && (
        <p>
          <b>
            {t("FIRST")} {t("ORDER")} {t("ON")}:
          </b>{" "}
          <br />
          {displayDateField(rowData.first_service_date)}
        </p>
      )}
      <p>
        <b>
          {t("TOTAL")} {t("ORDERS")}:
        </b>{" "}
        <br />
        <p> {displayField(rowData.total_order_count)}</p>
      </p>
      <p>
        <b>
          {t("TOTAL")} {t("HOME")} {t("SERVICE")}:
        </b>{" "}
        <br />
        <p> {displayField(rowData.home_service_count)}</p>
      </p>
      <p>
        <b>
          {t("CUSTOMER")} {t("CREATED")} {t("ON")}:
        </b>{" "}
        <br />
        <p> {displayDateTimeField(rowData.created_at)}</p>
      </p>
    </Popover>
  ) : (
    <Popover title={t("LAST") + " " + t("ORDER") + " " + t("ITEMS") + ":"}>
      <p>{t("NA")}</p>
      <p>
        <b>
          {t("CUSTOMER")} {t("CREATED")} {t("ON")}:
        </b>{" "}
        <br />
        <p> {displayDateTimeField(rowData.created_at)}</p>
      </p>
    </Popover>
  );
  return (
    <Cell {...props}>
      <Whisper
        placement="top"
        speaker={speaker}
        enterable={true}
        preventOverflow={true}
      >
        <a>{displayDateField(rowData.last_service_date)}</a>
      </Whisper>
    </Cell>
  );
};

export default LastOrderCell;
